/* global globalThis */
/**
 * MSAL configuration for Entra ID (Azure AD) authentication.
 *
 * The app acquires a token only for the authorization service (login + token).
 * That token is stored in sessionStorage and used for all backend service calls
 * (NA, accessories, reservation, reporting, etc.).
 *
 * Single-token flow: one backend app ID is used for all service calls.
 * Config key: globalThis.EMP.MSAL_BACKEND_APP
 */
const getClientId = () => globalThis.EMP?.MSAL_CLIENT_ID;

const getTenantId = () => globalThis.EMP?.MSAL_TENANT_ID;

const getBackendAppId = () => globalThis.EMP?.MSAL_BACKEND_APP || null;

/**
 * Scope name used for backend access token acquisition.
 */
const getBackendScopeName = () => globalThis.EMP?.MSAL_BACKEND_SCOPE || "emp-ui";

export const msalConfig = {
  auth: {
    clientId: getClientId(),
    authority: `https://login.microsoftonline.com/${getTenantId()}`,
    redirectUri: globalThis.location.origin,
    postLogoutRedirectUri: globalThis.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true, // Set to true for IE11/Edge
  },
};

/**
 * Scopes for acquiring token to call backend services.
 */
export const getBackendScopes = () => {
  const appId = getBackendAppId();

  if (!appId) {
    throw new Error(
      "MSAL_BACKEND_APP is not configured in window.EMP. " +
        "Set window.EMP.MSAL_BACKEND_APP to the Azure AD application ID of the backend service."
    );
  }

  const scopeName = getBackendScopeName();
  return [`api://${appId}/${scopeName}`];
};

/**
 * Entra ID logout URL. Redirect here to clear the Entra session.
 */
export const getLogoutUri = () => {
  const tenantId = getTenantId();

  if (!tenantId) {
    return null;
  }

  const postLogoutRedirectUri = encodeURIComponent(globalThis.location.origin);

  return `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/logout?post_logout_redirect_uri=${postLogoutRedirectUri}`;
};
